import i18n from '@/i18n'

/**
 * Remaining pause time in the interface language (e.g. "1 hora", "45 minutos").
 * Runs outside React, so the language is read at call time.
 */
export function formatPauseRemaining(diffMs: number): string {
  if (diffMs <= 0) return ''
  const t = i18n.getFixedT(null, 'common')

  const sec = Math.ceil(diffMs / 1000)
  const days = Math.floor(sec / 86400)
  const hours = Math.floor((sec % 86400) / 3600)
  const minutes = Math.floor((sec % 3600) / 60)

  if (days > 0) return t('time.days', { count: days })
  if (hours > 0) return t('time.hours', { count: hours })
  if (minutes > 0) return t('time.minutes', { count: minutes })
  return t('time.lessThanAMinute')
}

/**
 * UI state of the automation toggle. These are internal values compared in control flow,
 * never rendered as-is — do not translate them.
 */
export type AutomationUiState = 'ligada' | 'pausada' | 'desligada'

export function getAutomationUiState(contact: {
  assistant_is_active?: boolean | null
  assistant_disabled_until?: string | null
}): AutomationUiState {
  const active = contact.assistant_is_active ?? false
  const until = contact.assistant_disabled_until
  if (active) return 'ligada'
  if (!until) return 'desligada'
  // Pausa em curso: ainda não chegou na hora marcada.
  if (new Date(until).getTime() > Date.now()) return 'pausada'
  // Pausa vencida mas a flag ainda não foi flipada (cron / webhook / fast-path no painel).
  // Tratamos como ligada para a UI não mostrar "Desligada" enganosamente.
  return 'ligada'
}
